import { Box } from '@chakra-ui/react';
import { forwardRef, useImperativeHandle } from 'react';
import { FormBuilder } from '@/components/formBuilder';
import { useOfferStore } from '../store';

interface OfferDetailsProps {
  initialValues: any;
  detailsFormConfig: any[];
  detailsFormRef: any;
}

export const OfferDetails = forwardRef(
  (props: OfferDetailsProps, comRef: any) => {
    const {
      initialValues = {},
      detailsFormConfig = [],
      detailsFormRef: formRef,
    } = props;
    const setOfferPayload = useOfferStore((state) => state.setOfferPayload);

    useImperativeHandle(comRef, () => ({
      getModel: async () => {
        const formValues = formRef?.current?.values || {};
        formRef?.current?.validateForm();
        const isFormValid = formRef?.current?.isValid || false;
        const isValid = isFormValid;
        if (!isValid) {
          await formRef?.current?.submitForm();
          await new Promise((resolve) => setTimeout(resolve, 50));
          const customFieldsErrArray = Object.keys(formRef?.current?.errors);
          const invalidElements = document.querySelectorAll(
            '[aria-invalid="true"]'
          );

          if (invalidElements?.length > 0) {
            const errorElement = invalidElements[0];
            errorElement?.scrollIntoView?.({
              behavior: 'smooth',
              block: 'center',
            });
            return;
          }

          if (customFieldsErrArray?.length > 0) {
            var element = document?.getElementById?.(customFieldsErrArray?.[0]);
            element?.scrollIntoView?.({
              behavior: 'smooth',
              block: 'center',
            });
          }
        }
        if (isValid) {
          setOfferPayload(formValues);
        }
        return {
          hasValidData: isValid,
          payload: formValues,
        };
      },
    }));

    const handleDetailsFormSubmit = (values = {}) => {
      console.log('failed_modal_values', values);
    };

    return (
      <Box ref={comRef}>
        <Box h="100%" w="100%" overflowY="auto" overflowX="hidden" p="0">
          <FormBuilder
            initialValues={initialValues || {}}
            config={detailsFormConfig}
            onSubmit={handleDetailsFormSubmit}
            formRef={formRef}
          />
        </Box>
      </Box>
    );
  }
);
